import type { TFunction } from "i18next";

const EmergencyWidget = ({ level, t }: { level: string | boolean | undefined, t: TFunction }) => {
    return (
        <div className="p-4 bg-red-50 rounded-lg border border-red-200">
            <h3 className="text-sm font-bold text-red-700 mb-2">{t('poiModal.emergency.inProgress', { level })}</h3>
            <p className="text-xs text-red-600">{t('poiModal.emergency.instructions')}</p>
        </div>
    );
};

export default EmergencyWidget;